<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <path fill-rule="evenodd" d="M17.595 7.534c.54.541.54 1.418 0 1.959l-6.347 6.346a1.385 1.385 0 0 1-1.958 0l-2.884-2.885a1.385 1.385 0 0 1 1.958-1.958l1.905 1.906 5.367-5.368a1.387 1.387 0 0 1 1.959 0Z" clip-rule="evenodd"/>
</svg>
